import types from './types'

const initialState = {
  productMap: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CURRENT_PRODUCT_MAP:
      return {
        ...state,
        productMap: action.productMap,
      }
    default:
      return state
  }
}
